import styles from './NoizeValue.module.css';

export const NoizeValue = ({ noiseLevel }) => {
  const noiseLevelString = noiseLevel
    ? noiseLevel?.replaceAll('.', ',')?.split('')
    : '';

  const fontSize = '10.5rem';

  return (
    <div className={styles.noiseLevel} style={{ '--fontSize': fontSize }}>
      {noiseLevelString && (
        <div className={styles.stringValue}>
          {noiseLevelString?.map((l, i) => (
            <div key={i} className={`${l === ',' ? styles.comma : ''}`}>
              {l}
            </div>
          ))}
        </div>
      )}

      {/* <div className={styles.leftTop} />
      <div className={styles.rightTop} />
      <div className={styles.rightBottom} />
      <div className={styles.leftBottom} /> */}
    </div>
  );
};
